import gql from "graphql-tag";

export const ALL_DELIVERY_ZONES = gql`
    query ALL_DELIVERY_ZONES($page: Int!, $perPage: Int!) {
        zones (page: $page, perPage: $perPage) {
            objects {
                publicId,
                name,
                details,
                divider,
                location,
                createdAt,
                days {
                    publicId,
                    deliveryDay {
                        weekday,
                        calendarCode
                    }
                }
            }
        }
    }
`;

export const ADD_NEW_DELIVERY_ZONE = gql`
    mutation ADD_NEW_DELIVERY_ZONE($name: String!, $details: String!, $divider: String!, $location: String! ){
        zone(name: $name, details: $details, divider: $divider, location: $location) {
            zone {
                name,
            }
        }
    }
`;

export const UPDATE_DELIVERY_ZONE = gql`
    mutation UPDATE_DELIVERY_ZONE($id: ID!,$name: String!, $details: String!, $divider: String!, $location: String! ){
        zone(id: $id, name: $name, details: $details, divider: $divider, location: $location) {
            zone {
                name,
            }
        }
    }
`;

// TIMEZONES

export const ALL_TIMEZONES = gql`    
    query ALL_TIMEZONES($page: Int!, $perPage: Int!){
        timezones (page: $page, perPage: $perPage) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                timezoneName,
                timezoneStartTime,
                timezoneEndTime,
                createdAt,
                updatedAt,
                lastUpdatedBy {
                    publicId,
                    name
                }
            }
        }
    }
`;

export const ADD_NEW_TIMEZONE = gql`
    mutation ADD_NEW_TIMEZONE($timezoneEndTime: Time!, $timezoneStartTime: Time!, $timezoneName: String!){
        timezone(timezoneEndTime: $timezoneEndTime, timezoneStartTime: $timezoneStartTime, timezoneName: $timezoneName) {
            timezone {
                timezoneName,
                publicId
            }
        }
    }
`;

export const UPDATE_TIMEZONE = gql`
    mutation UPDATE_DELIVERY_ZONE($id: ID!,$timezoneEndTime: Time!, $timezoneStartTime: Time!, $timezoneName: String!){
        timezone(id: $id, timezoneEndTime: $timezoneEndTime, timezoneStartTime: $timezoneStartTime, timezoneName: $timezoneName) {
            timezone {
                timezoneName,
                publicId
            }
        }
    }
`;

// PUBLIC HOLIDAYS

export const ALL_PUBLIC_HOLIDAYS = gql`
    query ALL_PUBLIC_HOLIDAYS($page: Int!, $perPage: Int!){
        publicHolidays (page: $page, perPage: $perPage) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                publicHolidayName,
                publicHolidayDate,
                createdAt,
                updatedAt,
                lastUpdatedBy {
                    publicId,
                    name
                }
            }
        }
    }
`;

export const ADD_NEW_PUBLIC_HOLIDAY = gql`
    mutation ADD_NEW_PUBLIC_HOLIDAY($publicHolidayDate: Date!, $publicHolidayName: String!){
        publicHoliday(publicHolidayDate: $publicHolidayDate, publicHolidayName: $publicHolidayName) {
            publicHoliday {
                publicHolidayName,
                publicId
            }
        }
    }
`;

export const UPDATE_PUBLIC_HOLIDAY = gql`
    mutation UPDATE_PUBLIC_HOLIDAY($id: ID!,$publicHolidayDate: Date!, $publicHolidayName: String!){
        publicHoliday(id: $id, publicHolidayDate: $publicHolidayDate, publicHolidayName: $publicHolidayName) {
            publicHoliday {
                publicHolidayName,
                publicId
            }
        }
    }
`;

export const DELETE_PUBLIC_HOLIDAY = gql`
    mutation DELETE_PUBLIC_HOLIDAY($id: ID!){
        deletePublicHoliday(id: $id) {
            message
        }
    }
`;


// DAY ZONE ASSIGNMENTS
export const ALL_DAY_ZONE_ASSIGNMENTS = gql`
    query ALL_DAY_ZONE_ASSIGNMENTS($page: Int!, $perPage: Int!){
        assignedDays (page: $page, perPage: $perPage) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                zone {
                    publicId,
                    name,
                },
                deliveryDay {
                    publicId,
                    weekday,
                    calendarCode
                },
            }
        }
    }
`;

export const ADD_DAY_ZONE_ASSIGNMENT = gql`
    mutation ADD_DAY_ZONE_ASSIGNMENT($deliveryDay: String!, $zone: String!){
        assignedDay(deliveryDay: $deliveryDay, zone: $zone) {
            message,
            assignedDay {
                deliveryDay {
                    publicId,
                    weekday
                }
                zone {
                    publicId,
                    name
                },
            }
        }
    }
`;

export const UPDATE_DAY_ZONE_ASSIGNMENT = gql`
    mutation UPDATE_DAY_ZONE_ASSIGNMENT($id: ID!,$deliveryDay: String!, $zone: String!){
        assignedDay(id: $id, deliveryDay: $deliveryDay, zone: $zone) {
            message,
            assignedDay {
                deliveryDay {
                    publicId,
                    weekday
                }
                zone {
                    publicId,
                    name
                },
            }
        }
    }
`;

export const DELETE_DAY_ZONE_ASSIGNMENT = gql`
    mutation DELETE_DAY_ZONE_ASSIGNMENT($id: ID!){
        deleteAssignedDay(id: $id) {
            message
        }
    }
`;

// DELIVERY DAYS
export const ALL_DELIVERY_DAYS = gql`
    query ALL_DELIVERY_DAYS($page: Int!, $perPage: Int!){
        deliveryDays (page: $page, perPage: $perPage) {
            objects {
                publicId,
                weekday,
                calendarCode,
            }
        }
    }
`;
